module.exports = __webpack_public_path__ + "4c9a67222d0bbba0de2c156e0026adef.png";